import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/descubre-el-valor-estratégico-de-la-seguridad-en-medicamentos-en-empresas-de-life-sciences")({
  head: () => buildRouteHead("/es/descubre-el-valor-estratégico-de-la-seguridad-en-medicamentos-en-empresas-de-life-sciences", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/webinars", replace: true });
  },
});
